export default "__VITE_ASSET__5Ls48H$f__"